import { render, staticRenderFns } from "./BoardSidebar.vue?vue&type=template&id=877167f8&scoped=true"
import script from "./BoardSidebar.vue?vue&type=script&lang=js"
export * from "./BoardSidebar.vue?vue&type=script&lang=js"
import style0 from "./BoardSidebar.vue?vue&type=style&index=0&id=877167f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877167f8",
  null
  
)

export default component.exports